import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { isNotEmptyArray } from '@satin/core/utility';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@fabric/components/loading-spinner';
import { FabLoadingSpinnerModule } from '@fabric/components/loading-spinner';

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class LoadingService {
    constructor() {
        this.isLoading_ = [];
        this.loadingSubject = new Subject();
        this.loadingObservable = this.loadingSubject.asObservable();
    }
    //if we just want to subscribe
    subscribe(fn) {
        return this.loadingObservable.subscribe(fn);
    }
    startLoading() {
        this.isLoading_.push(true);
        this.loadingSubject.next(this.isLoading_);
    }
    finishLoading() {
        //Remove one count of loading
        this.isLoading_.splice(0, 1);
        this.loadingSubject.next(this.isLoading_);
    }
    isLoading() {
        return (isNotEmptyArray(this.isLoading_) && this.isLoading_.length > 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class LoadingIndicatorComponent {
    constructor(loadingService) {
        this.loadingService = loadingService;
        this.showLoadingIndicator = false;
    }
    ngOnInit() {
        this.sub = this.loadingService.subscribe(() => {
            this.showLoadingIndicator = this.loadingService.isLoading();
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorComponent, deps: [{ token: LoadingService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: LoadingIndicatorComponent, selector: "loading-indicator", ngImport: i0, template: "<fab-loading-spinner *ngIf=\"showLoadingIndicator\" id=\"loading-indicator\" color=\"accent\">\n</fab-loading-spinner>\n", styles: ["/*!\n * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n *//*!\n * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n */.overlay{position:fixed;width:100%;height:100%;inset:0;background-color:#00000080;z-index:10000;cursor:pointer}.loading-spinner{content:\"\";box-sizing:border-box;position:absolute;top:50%;left:50%;height:60px;width:60px;margin-top:-30px;margin-left:-30px;border-radius:50%;border:4px solid #d9d9d6;border-top-color:#5eb1f3;animation:spinner .8s linear infinite}@keyframes spinner{to{transform:rotate(360deg)}}\n"], dependencies: [{ kind: "directive", type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.FabLoadingSpinnerComponent, selector: "fab-loading-spinner", inputs: ["withOverlay", "color", "mode", "value"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'loading-indicator', template: "<fab-loading-spinner *ngIf=\"showLoadingIndicator\" id=\"loading-indicator\" color=\"accent\">\n</fab-loading-spinner>\n", styles: ["/*!\n * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n *//*!\n * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.\n * This information is confidential and proprietary to GM Global Technology\n * Operations LLC and may not be used, modified, copied or distributed.\n */.overlay{position:fixed;width:100%;height:100%;inset:0;background-color:#00000080;z-index:10000;cursor:pointer}.loading-spinner{content:\"\";box-sizing:border-box;position:absolute;top:50%;left:50%;height:60px;width:60px;margin-top:-30px;margin-left:-30px;border-radius:50%;border:4px solid #d9d9d6;border-top-color:#5eb1f3;animation:spinner .8s linear infinite}@keyframes spinner{to{transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: function () { return [{ type: LoadingService }]; } });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class LoadingIndicatorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorModule, declarations: [LoadingIndicatorComponent], imports: [CommonModule,
            FabLoadingSpinnerModule], exports: [LoadingIndicatorComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorModule, providers: [
            LoadingService
        ], imports: [CommonModule,
            FabLoadingSpinnerModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: LoadingIndicatorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        LoadingIndicatorComponent
                    ],
                    providers: [
                        LoadingService
                    ],
                    imports: [
                        CommonModule,
                        FabLoadingSpinnerModule
                    ],
                    exports: [
                        LoadingIndicatorComponent
                    ],
                }]
        }] });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LoadingIndicatorComponent, LoadingIndicatorModule, LoadingService };
